import {Injectable} from "@angular/core";

@Injectable()
export class numberOnly {
  check(event) {
    if (event.charCode == 8 || event.charCode == 0) {
      return null
    } else {
      return event.charCode >= 48 && event.charCode <= 57
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/services/onlyNumberKey.ts